import { useT } from "../i18n/LanguageContext";

export default function Footer() {
    const { t } = useT();
    return (
        <footer
            className="relative py-14 bg-charcoal border-t border-white/10"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                <div className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-sm bg-gold flex items-center justify-center text-charcoal font-display font-black text-sm">
                        W
                    </span>
                    <div className="leading-none">
                        <div className="font-display text-sm font-bold tracking-wide">
                            {t("brand.title")}
                        </div>
                        <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">
                            by {t("brand.subtitle")}
                        </div>
                    </div>
                </div>

                <div className="text-xs text-white/40 text-center">
                    © {new Date().getFullYear()} {t("footer.copyright")}
                </div>

                <div className="flex justify-start md:justify-end gap-6 text-[11px] tracking-[0.25em] uppercase text-white/50">
                    <a href="#contact" className="hover:text-gold">{t("footer.contact")}</a>
                    <a href="#invest" className="hover:text-gold">{t("footer.invest")}</a>
                    <a href="/admin/login" className="hover:text-gold" data-testid="footer-admin-link">{t("footer.admin")}</a>
                </div>
            </div>
            <p className="mx-auto max-w-7xl px-6 md:px-12 mt-10 text-[10px] text-white/30 italic leading-relaxed">
                {t("footer.legal")}
            </p>
        </footer>
    );
}
